import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import refs from '../helpers/refs'

class CSliderPDP {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.initSlider()
    this.bindEvents()
  }

  initSlider () {
    this.glide = new Glide(this.$refs.slider, {
      type: 'slider',
      autoheight: true,
      gap: 32,
      perView: 2.3,
      bound: true,
      breakpoints: {
        768: {
          perView: 1.3,
          gap: 16
        }
      }
    }).mount({ Controls, Keyboard, Breakpoints, Swipe })
  }

  bindEvents () {
    // Check if $refs is defined first
    if (this.$refs) {
      // Check if $refs.next is defined
      if (this.$refs.next) {
        // If $refs.next is an array
        if (Array.isArray(this.$refs.next)) {
          // Attach the event listener to each element in the array
          this.$refs.next.forEach((nextItem) => {
            nextItem.addEventListener('click', (e) => {
              this.glide.go('>')
            })
          })
        } else {
        // If $refs.next is a single element
          this.$refs.next.addEventListener('click', (e) => {
            this.glide.go('>')
          })
        }
      }

      // Same logic for $refs.prev
      if (this.$refs.prev) {
        if (Array.isArray(this.$refs.prev)) {
          this.$refs.prev.forEach((prevItem) => {
            prevItem.addEventListener('click', (e) => {
              this.glide.go('<')
            })
          })
        } else {
          this.$refs.prev.addEventListener('click', (e) => {
            this.glide.go('<')
          })
        }
      }
    }

    if (this.$refs && this.$refs.controls && Array.isArray(this.$refs.controls)) {
      this.$refs.controls.forEach((control, i) => {
        if (control) {
          control.addEventListener('click', (e) => {
            this.glide.go(`=${i}`)
            this.setControls(i)
          })
        }
      })
    }

    this.glide.on('run', () => {
      this.setControls(this.glide.index)
    })
  }

  setControls (index) {
    if (this.$refs.controls) {
      this.$refs.controls.forEach((control, i) => {
        control.classList.toggle('--active', i === index)
      })
    }
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('.c-slider-pdp')
    .forEach(el => new CSliderPDP(el))
})
